import React from "react";

import { Page } from "./Page";

import { MetaWrapper } from "../../components/Meta";

export function DataPolicyView() {
  return (
    <MetaWrapper
      meta={{
        title: "Piroshky Piroshky Bakery - Policy Center",
        description: "Piroshky Piroshky Bakery's policy center",
      }}
    >
      <Page/>
    </MetaWrapper>
  );
}
